module.exports = __webpack_public_path__ + "img/logo.5d0a2644.svg";